import * as React from "react";
import {
  ChipField,
  Datagrid,
  EditButton,
  Filter,
  List,
  SearchInput,
  TextField,
  ListActions,
  usePermissions,
} from "react-admin";
import { isInternalAdmin, readOnly } from "../../auth-provider";

const NameFilter = (props) => (
  <Filter {...props}>
    <SearchInput source="ids" alwaysOn />
  </Filter>
);

export const AssessmentList = ({ ...props }) => {
  const permissions = usePermissions();

  return (
    <List
      {...props}
      perPage={25}
      sort={{ field: "name", order: "ASC" }}
      actions={isInternalAdmin(permissions.permissions) ? <ListActions /> : null}
      filters={<NameFilter />}
    >
      <Datagrid rowClick="show" bulkActionButtons={false}>
        <TextField source="id" />
        <TextField source="name" />
        <TextField source="description" />
        <ChipField source="type" />
        <TextField
          source="externalAssessmentId"
          label="External Assessment Id"
        />
        <TextField source="provider" />
        {!readOnly(permissions.permissions) && <EditButton />}
      </Datagrid>
    </List>
  );
};
